import { gql } from "@apollo/client"

const UPDATE_PASSWORD = gql`
  mutation UpdateUser(
    $password: String!
    $id: ID!
  ) {
    updateUser(
      input: {
        id: $id
        password: $password
      }
    ) { 
      user {
        id
      }
    }
  }
`

export default UPDATE_PASSWORD
